import { useField } from "formik";
import { useCallback, useMemo } from "react";
import { toItemList } from "src/types/groupedItems";
import { Item, SearchSelect, SearchSelectProps } from "./SearchSelect";

export type FormikSearchSelectProps<T extends Item> = {
  name: string;
} & Omit<SearchSelectProps<T>, "selectedItem" | "onChange">;
export function FormikSearchSelect<T extends Item>({
  name,
  ...props
}: FormikSearchSelectProps<T>) {
  const { items } = props;

  const [field, meta, helper] = useField(name);
  const selectedItem = useMemo(() => {
    return toItemList(items).find((item) => item.key === field.value) ?? null;
  }, [field.value, items]);

  const onChange = useCallback(
    (item: T | null) => {
      helper.setTouched(true);
      if (item === null) {
        helper.setValue(undefined);
        return;
      }

      helper.setValue(item.key);
    },
    [helper]
  );

  return (
    <SearchSelect<T>
      {...props}
      error={meta.error}
      onChange={onChange}
      selectedItem={selectedItem}
    />
  );
}
